import { createSelector } from "reselect";

import { ApplicationScope } from "@superblocksteam/shared";

import type { AppState } from "store/types";

import type { StateVarMap } from "./slice";

const getStateVars = (state: AppState) => state.application.stateVars;

// All state vars are page-scoped for now. Revisit when adding app scope, probably need to split the selectors
export const getAllStateVars = createSelector([getStateVars], (stateVars) => ({
  ...stateVars[ApplicationScope.APP],
  ...stateVars[ApplicationScope.PAGE],
}));

export const getScopedStateVars = createSelector(
  [getStateVars, (_: AppState, scope: ApplicationScope) => scope],
  (state: StateVarMap, scope: ApplicationScope) => {
    return state[scope];
  },
);

export const getAllStateVarNames = createSelector(
  [getAllStateVars],
  (stateVars) => {
    return Object.values(stateVars || {}).map((stateVar) => stateVar.name);
  },
);

export const getScopedStateVarNames = (
  state: AppState,
  scope: ApplicationScope,
) =>
  Object.values(getScopedStateVars(state, scope)).map(
    (stateVar) => stateVar.name,
  );
